export default (theme) => ({
  root: {
    padding: '25px 25px 0 25px',
    borderRadius: '50px',
    width: '90%',
    '&:last-child': {
      marginRight: '0',
    },
    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '70%',
    },
  },
  img: {
    width: '60px',
    height: '170px',
    display: 'block',
    maxWidth: 400,
    overflow: 'hidden',
  },
  item: {
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  dot: {
    backgroundImage: theme.gradients.lightGreyGradient,
    border: theme.borders.greyBorder(false),
  },
  dotActive: {
    backgroundImage: theme.gradients.darkGreyGradient,
  },
  mobileStepper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '10px 0',
    background: 'transparent',
  },
});
